// extracted by css-extract-rspack-plugin
module.exports =  {"container":"OCRScopingJobsContent__container___AZX1b","toggleButtonContainer":"OCRScopingJobsContent__toggleButtonContainer___dqtT2"};